export enum SupportRequestType {
  MISSING_INVOICE = 'missing-invoice',
  CONTACT_US = 'contactus',
}
